import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const StickyBoxStyle = ({ theme, isStickyTop, topPosition = 80 }) => ({
  position: 'fixed',
  zIndex: 11,
  top: isStickyTop ? `${topPosition}px !important` : `calc(100vh - 190px)`,
  left: '16px',
  right: '16px',
  [theme.breakpoints.up('md')]: {
    top: 'calc(100vh - 123px)',
    // 92px is width of the left navigation
    // 5% is the padding of zendash page
    left: 'calc(5% + 92px);',
    right: '5%'
  }
});

export const StickyBoxStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'topPosition' && prop !== 'isStickyTop'
})(StickyBoxStyle);
